import { createAction } from "@reduxjs/toolkit";
export const resetOnChangeArea = createAction("resetAreaData");
export const resetOnChangeStore = createAction("resetStoreData");
export const resetOnChangeCartWithStore = createAction(
  "resetCartWithStoreData"
);
export const removeOrderData = createAction("removeOrderData");
